import React from 'react';
import { Grid, Stack, Typography } from 'components/ui';
import { FormattedMessage } from 'react-intl';
import { IndexListItem } from 'components/styles_components/list';
import useMobile from 'hooks/use_mobile';
import Date from 'components/date';
import State from 'components/space/order/state';

const ListItem = ({ order }) => {
  const isMobile = useMobile();

  if (isMobile) {
    return (
      <IndexListItem>
        <Grid container justifyContent="center" alignItems="center" spacing={2}>
          <Grid size={{ xs: 12 }}>
            <Stack>
              <Typography variant="button">{order.plan.name}</Typography>
              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                <FormattedMessage id="order.orderId" />: {order.id}
              </Typography>
              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                <FormattedMessage id="order.amount" />: {(order.amount / 100).toFixed(2)} {order.currency}
              </Typography>
              <State status={order.status} />
            </Stack>
          </Grid>
        </Grid>
      </IndexListItem>
    );
  }

  return (
    <IndexListItem>
      <Grid container justifyContent="center" alignItems="center">
        <Grid size={{ xs: 2.4 }} textAlign="left">
          <Typography variant="button">{order.plan.name}</Typography>
        </Grid>
        <Grid size={{ xs: 2.4 }} textAlign="center">
          <Typography variant="body2">{order.id}</Typography>
        </Grid>
        <Grid size={{ xs: 2.4 }} textAlign="center">
          <Typography variant="body2">{(order.amount / 100).toFixed(2)} {order.currency}</Typography>
        </Grid>
        <Grid size={{ xs: 2.4 }} textAlign="center">
          <State status={order.status} />
        </Grid>
        <Grid size={{ xs: 2.4 }} textAlign="center">
          <Date date={order.createdAt} />
        </Grid>
      </Grid>
    </IndexListItem>
  );
};

export default React.memo(ListItem);
